import React from 'react';
import { createComponent } from '@lit/react';
import { SDSTag } from '../sds-tag/sds-tag';

export const SDSTagWrapper = createComponent({
	tagName: 'sds-tag',
	elementClass: SDSTag,
	react: React,
	events: {},
});
